"use client"

import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

export const awards = [
	{
		name: 'Channel Pro Award',
		image_dark: '/img/CP_award.png',
		image_light: '/img/CP_award-light.png',
		description: '',
		link: 'https://www.channelpronetwork.com/2025/11/17/irvine-cybersecurity-conference-for-msps/'
	},
	{
		name: 'Channel Pro Live Editor\'s Choice Award',
		image_light: '/img/2023-CP-Event-Award-Editor-sChoiceAward-dark-bg.png',
		image_dark: '/img/2026_CP_Event_Award-Editors-Choice-Award.png',
		description: '',
		link: 'https://events.channelpronetwork.com/'
	},
	{
		name: 'Channel Pro Best Software Solution Award',
		image_light: '/img/2026-CP-Award-BestSoftware-dark-bg.png',
		image_dark: '/img/2026-CP-Award-BestSoftware-light.png',
		description: '',
		link: 'https://events.channelpronetwork.com/'
	},
	{
		name: 'XCellence in Boardroom Execution',
		label: 'Award Finalist',
		logo: '/img/xchange-logo.png',
		description: '',
		link: 'https://event.thechannelco.com/xchange-august/'
	}
];




const Compliance = ({ title = 'Industry Recognitions', subtitle, items = awards }) => {
	const { theme } = useContext(ThemeContext);



	const certifications = items.map((el, index) => {
		const { name, logo, image_dark, image_light, description, link, label } = el;
		const imgSrc = logo || (theme === 'dark' ? image_light : image_dark);
		const badge = label
			? (
				<div className='compliance-text-badge'>
					<span className='badge-label'>{label}</span>
					{imgSrc && <img className='badge-logo' src={imgSrc} alt={name} />}
					<b className='badge-name'>{name}</b>
				</div>
			)
			: <div className='compliance-logo' style={{ backgroundImage: `url(${imgSrc})` }} aria-label={name}></div>;
		return (
			<div key={index} className='compliance-item'>
				{link ? <a href={link}>{badge}</a> : badge}
				{description && <p className='compliance-description'>{description}</p>}
			</div>
		);
	});

	return (
		<section className='compliance'>
			<div className='container'>
				{title && (
					<div className='subtitle-container'>
						<h3 className='subtitle'>{title}</h3>
					</div>
				)}
				<div className='compliance-grid'>{certifications}</div>
			</div>
		</section>
	);
};

export default Compliance;
